import initGalleries from '@resources/js/components/galleries'

initGalleries()
